import { Entity, RELATION_PART_OF } from '@mainstage/catalog-model';
import { getEntityRelations } from '@mainstage/plugin-catalog-react';

export const extractPartOfSystemRelations = (entity: Entity) => {
  const partOfSystemRelations = getEntityRelations(entity, RELATION_PART_OF, {
    kind: 'system',
  });
  return partOfSystemRelations;
};
